import { IDs } from '../../helpers/IDs';
import * as React from 'react';
import { WFormsTableWrapper } from '../../core/table/WFormsTableWrapper';

export class Kontakt extends React.Component<{}, {}> {

    constructor(props: any) {
        super(props);
        this.state = {};
    }

    render(): JSX.Element {
        return (
            <WFormsTableWrapper
                entity={IDs.ENT_KONTAKT}
                module={IDs.MOD_ETOOL_ADMIN}
                actions={['view', 'delete']}
                customClass='Custom-ETA'
                customCssStyle={{
                    formField: { text: { styleTextarea: { height: 200 } } }
                }}
                formLayout='flowV2'
                customFormConfig={{ timestamp: { hidden: false } }}
                showingColumns={['timestamp']}
                showColumnsHelp
            />
        );
    }
}
